import { GameRowValue } from '@sg/backend/src/lib/db/getGameOr404.ts'
import { createElementSize } from "@solid-primitives/resize-observer"
import { Component, createEffect, createSignal } from 'solid-js'
import { createMutable } from 'solid-js/store'
import bindEngineToComponent from '../lib/canvas/bindEngineToComponentV1'
import createEngineForUI from '../lib/core/engine/createEngineForUI'
import { Engine } from '../lib/core/engine/Engine.type'
import syncEngineWithPropsRow from '../lib/core/engine/syncEngineWithPropsRow'
import createCanvasListStyleEffect from '../rx/effect/createCanvasListStyleEffect'
import createSetEngineAuthPlayerIdFromAuthProfileSignalEffect from '../rx/effect/createSetEngineAuthPlayerIdFromAuthProfileSignalEffect'
import { getAuthProfile } from '../rx/shared/profile/createAuthProfileSignal'
import EngineContext from './EngineContext'
import ZoomCardWidget from './Hud/ZoomCardWidget'

interface Props {
  row: GameRowValue,
  width: number,
  height: number,
  minWidth?: number,
  minHeight?: number,
}

/**
 * @deprecated
 */
const GameShowCanvas: Component<Props> = (props) => {
  throw new Error('Deprecated: GameShowCanvas')
  const engine: Engine = createMutable(createEngineForUI())
  // engine.state = createRandomMap(30, 20)

  createEffect(() => {
    syncEngineWithPropsRow(engine, props.row)
  })

  createSetEngineAuthPlayerIdFromAuthProfileSignalEffect(engine, getAuthProfile)


  const [containerStyles, setContainerStyles] = createSignal<Partial<CSSStyleDeclaration>>({})

  const [target, setTarget] = createSignal<HTMLElement>()

  const elementSize = createElementSize(target)

  createCanvasListStyleEffect(engine, props, elementSize, setContainerStyles)

  bindEngineToComponent(engine)

  return <EngineContext.Provider value={engine}>
    <div class="game-show-container" ref={setTarget} style={containerStyles() as string}>
      {'engine.canvasList'}
      <ZoomCardWidget />
    </div>
  </EngineContext.Provider>
}

export default GameShowCanvas